/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const RegularCopyAlt = ({ className }) => {
  return (
    <svg
      className={`regular-copy-alt ${className}`}
      fill="none"
      height="18"
      viewBox="0 0 18 18"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g className="g" clipPath="url(#clip0_2627_347)">
        <path
          className="path"
          d="M9.82869 14.6589C10.78 14.6577 11.692 14.2793 12.3647 13.6066C13.0374 12.934 13.4158 12.0219 13.4169 11.0706V4.78619C13.418 4.40897 13.3443 4.03527 13.1999 3.68677C13.0555 3.33827 12.8434 3.02189 12.5758 2.75597L10.9669 1.147C10.701 0.879445 10.3846 0.66733 10.0361 0.522952C9.68757 0.378573 9.31388 0.304804 8.93665 0.305921H5.52281C4.5715 0.30706 3.65948 0.685471 2.9868 1.35815C2.31412 2.03083 1.93571 2.94285 1.93457 3.89416V11.0706C1.93571 12.0219 2.31412 12.934 2.9868 13.6066C3.65948 14.2793 4.5715 14.6577 5.52281 14.6589H9.82869ZM3.36986 11.0706V3.89416C3.36986 3.32316 3.59669 2.77555 4.00045 2.3718C4.4042 1.96804 4.95181 1.74121 5.52281 1.74121C5.52281 1.74121 9.05291 1.75126 9.11104 1.75844V3.17651C9.11104 3.55717 9.26226 3.92225 9.53143 4.19141C9.8006 4.46058 10.1657 4.6118 10.5463 4.6118H11.9644C11.9716 4.66993 11.9816 11.0706 11.9816 11.0706C11.9816 11.6416 11.7548 12.1892 11.351 12.593C10.9473 12.9967 10.3997 13.2236 9.82869 13.2236H5.52281C4.95181 13.2236 4.4042 12.9967 4.00045 12.593C3.59669 12.1892 3.36986 11.6416 3.36986 11.0706ZM16.2875 6.0471V13.9412C16.2864 14.8925 15.908 15.8045 15.2353 16.4772C14.5626 17.1499 13.6506 17.5283 12.6993 17.5294H6.24045C6.05012 17.5294 5.86758 17.4538 5.733 17.3193C5.59842 17.1847 5.52281 17.0021 5.52281 16.8118C5.52281 16.6215 5.59842 16.4389 5.733 16.3043C5.86758 16.1698 6.05012 16.0942 6.24045 16.0942H12.6993C13.2703 16.0942 13.8179 15.8673 14.2216 15.4636C14.6254 15.0598 14.8522 14.5122 14.8522 13.9412V6.0471C14.8522 5.85676 14.9278 5.67423 15.0624 5.53964C15.197 5.40506 15.3795 5.32945 15.5699 5.32945C15.7602 5.32945 15.9427 5.40506 16.0773 5.53964C16.2119 5.67423 16.2875 5.85676 16.2875 6.0471Z"
          fill="white"
        />
      </g>

      <defs className="defs">
        <clipPath className="clip-path" id="clip0_2627_347">
          <rect
            className="rect"
            fill="white"
            height="17.2235"
            transform="translate(0.5 0.305908)"
            width="17.2235"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
